/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from 'react';

function UnathenticatedPage() {
  return (
    <div style={styles.unathenticatedContainer}>
      <h1  style={styles.unathenticatedNumber}>401</h1>
      <h2 style={styles.unathenticatedTitle}>Accés Denegat</h2>
      <p style={styles.unathenticatedMessage}>
        Ho sentim, necessitas logearte per accedir a aquesta página.
      </p>
    </div>
  );
}

export default UnathenticatedPage;

const styles = {
  unathenticatedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f8f8f8',
  },
  unathenticatedNumber:{
    fontSize: '148px',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  unathenticatedTitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  unathenticatedMessage: {
    fontSize: '16px',
    color: '#555',
    textAlign: 'center',
    maxWidth: '400px',
  },
};
